import { z } from "zod";
import { collectNodeFieldSchema } from "../collect-node/fields";

export const collectFormNodeSchema = z.object({
  nodeId: z.string(),
  message: z.string().min(1, "Please enter valid message"),
  openButtonText: z
    .string()
    .min(1, "Please enter valid button text")
    .max(45, "Button text should be precise and under 45 characters"),
  title: z
    .string()
    .min(1, "Please enter valid title")
    .max(45, "Title should be precise and under 45 characters"),
  submitButtonText: z
    .string()
    .min(1, "Please enter valid button text")
    .max(45, "Button text should be precise and under 45 characters"),
  fields: z.array(collectNodeFieldSchema),
  isValid: z.boolean().default(true),
});

export type CollectFormNodeSchema = z.infer<typeof collectFormNodeSchema>;

export const defaultCollectFormNodeValues: CollectFormNodeSchema = {
  nodeId: "",
  title: "",
  fields: [],
  isValid: true,
  openButtonText: "",
  message: "",
  submitButtonText: "",
};
